import { Component, OnInit } from '@angular/core';

import { DashboardSummary } from '../../models/api.models';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {
  summary: DashboardSummary = {
    onboardingStatus: 'Pending setup',
    activeTemplates: 4,
    totalContacts: 1240,
    campaignsSent: 12,
    deliveryRate: 97.8,
    recentLogs: [
      {
        id: 1,
        campaign_name: 'April Offers',
        contact_name: 'Aanya Retail',
        template_name: 'promo_launch_v1',
        delivery_status: 'delivered',
        sent_at: '2026-04-04T09:15:00+05:30',
      },
      {
        id: 2,
        campaign_name: 'Follow-up Utility',
        contact_name: 'Rahul Traders',
        template_name: 'invoice_nudge',
        delivery_status: 'queued',
        sent_at: '2026-04-04T10:05:00+05:30',
      },
    ],
  };

  constructor(private readonly dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.dashboardService.summary().subscribe({
      next: (response) => {
        this.summary = response;
      },
    });
  }
}
